/* SI Creations: the phone menu and the question rows. No library. */
(function () {
  'use strict';

  function setupMenu() {
    var button = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (!button || !menu) return;
    var icon = button.querySelector('span');
    function setOpen(open) {
      menu.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (icon) icon.className = open ? 'st-x' : 'st-bars';
    }
    setOpen(false);
    button.addEventListener('click', function () { setOpen(menu.hidden); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) { setOpen(false); button.focus(); }
    });
  }

  function setupFaq() {
    var rows = document.querySelectorAll('[data-faq]');
    Array.prototype.forEach.call(rows, function (row) {
      var summary = row.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', row.open ? 'true' : 'false');
      row.addEventListener('toggle', function () {
        if (summary) summary.setAttribute('aria-expanded', row.open ? 'true' : 'false');
      });
    });
  }

  /* the home page buy bar on a phone: it rises once the hero button has scrolled away, and hides while any
     button marked data-bar-watch is on screen, so two buttons never show at once. Fixed to the window, so it
     moves to the body (the store container would hold it). */
  function setupBar() {
    var bar = document.querySelector('[data-home-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watch = Array.prototype.slice.call(document.querySelectorAll('[data-bar-watch]'));
    if (!watch.length) return;
    document.body.appendChild(bar);
    bar.inert = true;
    bar.hidden = false;
    var phone = window.matchMedia ? window.matchMedia('(max-width: 899.98px)') : { matches: true };
    var seen = watch.map(function () { return false; }), passed = false;
    function place() {
      var on = phone.matches && passed && seen.indexOf(true) < 0;
      bar.classList.toggle('on', on);
      bar.inert = !on;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        seen[watch.indexOf(en.target)] = en.isIntersecting;
        if (en.target === watch[0] && !en.isIntersecting && en.boundingClientRect.top < 0) passed = true;
      });
      place();
    });
    watch.forEach(function (el) { io.observe(el); });
    if (phone.addEventListener) phone.addEventListener('change', place); else if (phone.addListener) phone.addListener(place);
  }

  /* pictures below the first screen that wait (data-later): nothing more is fetched for a visitor who only looks at the
     first screen. The first scroll, tap or key starts a watch that fetches each one as it nears the screen; anything
     already on screen, or the theme editor, gets them at once. */
  function setupLater() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-later]'));
    if (!imgs.length) return;
    function load(img) {
      if (!img.hasAttribute('data-later')) return;
      img.removeAttribute('data-later');
      var set = img.getAttribute('data-srcset'), src = img.getAttribute('data-src');
      if (set) img.setAttribute('srcset', set);
      if (src) img.setAttribute('src', src);
    }
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { imgs.forEach(load); return; }
    imgs.forEach(function (img) { var r = img.getBoundingClientRect(); if (r.width > 0 && r.bottom > 0 && r.top < window.innerHeight) load(img); });
    var acts = ['scroll', 'pointerdown', 'keydown', 'touchstart'], started = false;
    function start() {
      if (started) return;
      started = true;
      acts.forEach(function (t) { window.removeEventListener(t, start); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px 900px 0px' });
      imgs.forEach(function (img) { if (img.hasAttribute('data-later')) io.observe(img); });
    }
    acts.forEach(function (t) { window.addEventListener(t, start, { passive: true }); });
    if (window.pageYOffset > 0) start();
  }

  function ready() { setupMenu(); setupFaq(); setupBar(); setupLater(); }
  document.addEventListener('shopify:section:load', function () { Array.prototype.forEach.call(document.querySelectorAll('img[data-later]'), function (img) { img.removeAttribute('data-later'); if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset')); if (img.getAttribute('data-src')) img.setAttribute('src', img.getAttribute('data-src')); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
